//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldDisplayItem } from './CustomFieldDisplayItem';
import { ICustomFieldWithRequired } from './ICustomFieldWithRequired';
import { CustomFieldType } from './Enums';

export class CustomFieldPolicyDisplayItem extends CustomFieldDisplayItem implements ICustomFieldWithRequired {
    Required: boolean = false;
    Statement: string | null = null;
    Url: string | null = null;
    WebsiteMediaLibraryItemID: string | null = null;
    override readonly FieldType: CustomFieldType = CustomFieldType.Policy;

    constructor(initializer?: Partial<Omit<CustomFieldPolicyDisplayItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldPolicyDisplayItem";
}
